import {
  SET_FORM_DATA,
  SET_FORM_LOADING,
  SET_CUISINE_TYPE_ID,
  SET_DESCRIPTION,
  SET_FORM_TYPE_ID,
  SET_HEATING_REQUIRED,
  SET_IMAGE_PATH,
  SET_IS_ACTIVE,
  SET_IS_SPECIAL,
  SET_IS_VEG,
  SET_MEAL_TYPE_ID,
  SET_NAME,
  SET_PACKAGING_WEIGHT,
  SET_PRODUCT_ID,
  SET_QUANTITY_TYPE_ID,
  SET_QUANTITY_VALUE,
  SET_SERVING,
  SET_SHELF_LIFE,
  SET_TAX_TYPE_ID,
  SET_TITLE,
  SET_SUBMIT_LOADING
} from './constants';

export function setFormLoading(loading) {
  return {
    type: SET_FORM_LOADING,
    loading
  };
}

export function setFormDataToStore(formData) {
  return {
    type: SET_FORM_DATA,
    formData
  };
}

export function setVariantName(name) {
  return {
    type: SET_NAME,
    name
  };
}

export function setVariantTitle(title) {
  return {
    type: SET_TITLE,
    title
  };
}

export function setVariantDescription(description) {
  return {
    type: SET_DESCRIPTION,
    description
  };
}

export function setVariantProductId(productId) {
  return {
    type: SET_PRODUCT_ID,
    productId
  };
}

export function setVariantQuantityTypeId(quantityTypeId) {
  return {
    type: SET_QUANTITY_TYPE_ID,
    quantityTypeId
  };
}

export function setVariantFormTypeId(formTypeId) {
  return {
    type: SET_FORM_TYPE_ID,
    formTypeId
  };
}

export function setVariantMealTypeId(mealTypeId) {
  return {
    type: SET_MEAL_TYPE_ID,
    mealTypeId
  };
}

export function setVariantCuisineTypeId(cuisineTypeId) {
  return {
    type: SET_CUISINE_TYPE_ID,
    cuisineTypeId
  };
}

export function setVariantTaxTypeId(taxTypeId) {
  return {
    type: SET_TAX_TYPE_ID,
    taxTypeId
  };
}

export function setVariantIsSpecial(isSpecial) {
  return {
    type: SET_IS_SPECIAL,
    isSpecial
  };
}

export function setVariantIsVeg(isVeg) {
  return {
    type: SET_IS_VEG,
    isVeg
  };
}

export function setVariantIsActive(isActive) {
  return {
    type: SET_IS_ACTIVE,
    isActive
  };
}

export function setVariantShelfLife(shelfLife) {
  return {
    type: SET_SHELF_LIFE,
    shelfLife
  };
}

export function setVariantMicrowaveHeatingRequired(microwaveHeatingRequired) {
  return {
    type: SET_HEATING_REQUIRED,
    microwaveHeatingRequired
  };
}

export function setVariantServing(serving) {
  return {
    type: SET_SERVING,
    serving
  };
}

export function setVariantQuantityValue(quantityValue) {
  return {
    type: SET_QUANTITY_VALUE,
    quantityValue
  };
}

export function setVariantWithPackagingWeight(withPackagingWeight) {
  return {
    type: SET_PACKAGING_WEIGHT,
    withPackagingWeight
  };
}

export function setVariantImagePath(imagePath) {
  return {
    type: SET_IMAGE_PATH,
    imagePath
  };
}

export function setSubmitLoading(submitLoading) {
  return {
    type: SET_SUBMIT_LOADING,
    submitLoading
  };
}



// WEBPACK FOOTER //
// ./src/Modules/CreateNewVariant/actions.js